// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-navbar {
  position: sticky !important;
  top: 0;
  z-index: 1100;
  width: 100%;
  background: #ffffff;
  border-bottom: 1px solid rgba(12, 20, 39, 0.06);
  box-shadow: 0 12px 30px rgba(12, 20, 39, 0.08);
  padding: 10px 18px;
}

.admin-navbar .container-fluid {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0;
}

.admin-navbar .navbar-brand {
  font-weight: 800;
  letter-spacing: -0.01em;
  color: #0f172a;
}

.admin-navbar .navbar-nav .nav-item {
  display: flex;
  align-items: center;
}

.admin-navbar .navbar-nav .nav-item a.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f8fafc;
  color: #0f172a;
  border: 1px solid rgba(12, 20, 39, 0.08);
  padding: 10px 14px;
  border-radius: 12px;
  text-transform: none;
  box-shadow: none;
}

.admin-navbar .navbar-nav .nav-item a.btn-primary mat-icon {
  color: #1d4ed8;
}

.admin-navbar .navbar-toggler {
  border: 1px solid rgba(12, 20, 39, 0.12);
}

.admin-navbar .navbar-collapse {
  flex-grow: 1;
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./projects/admin/src/components/core/navbar/navbar.component.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,MAAM;EACN,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,+CAA+C;EAC/C,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B","sourcesContent":[".admin-navbar {\n  position: sticky !important;\n  top: 0;\n  z-index: 1100;\n  width: 100%;\n  background: #ffffff;\n  border-bottom: 1px solid rgba(12, 20, 39, 0.06);\n  box-shadow: 0 12px 30px rgba(12, 20, 39, 0.08);\n  padding: 10px 18px;\n}\n\n.admin-navbar .container-fluid {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin: 0;\n}\n\n.admin-navbar .navbar-brand {\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  color: #0f172a;\n}\n\n.admin-navbar .navbar-nav .nav-item {\n  display: flex;\n  align-items: center;\n}\n\n.admin-navbar .navbar-nav .nav-item a.btn-primary {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #f8fafc;\n  color: #0f172a;\n  border: 1px solid rgba(12, 20, 39, 0.08);\n  padding: 10px 14px;\n  border-radius: 12px;\n  text-transform: none;\n  box-shadow: none;\n}\n\n.admin-navbar .navbar-nav .nav-item a.btn-primary mat-icon {\n  color: #1d4ed8;\n}\n\n.admin-navbar .navbar-toggler {\n  border: 1px solid rgba(12, 20, 39, 0.12);\n}\n\n.admin-navbar .navbar-collapse {\n  flex-grow: 1;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
